"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MSAL = void 0;
var axios_1 = __importDefault(require("axios"));
var lodash_1 = require("lodash");
var winston_1 = __importDefault(require("winston"));
var types_1 = require("./types");
var UserAgentApplicationExtended_1 = require("./UserAgentApplicationExtended");
var MSAL = (function () {
    function MSAL(config) {
        this.config = config;
        this.authConfig = {
            clientId: "",
            tenantId: "common",
            tenantName: "login.microsoftonline.com",
            validateAuthority: true,
            redirectUri: window.location.href,
            postLogoutRedirectUri: window.location.href,
            navigateToLoginRequestUrl: true,
            requireAuthOnInitialize: false,
            autoRefreshToken: true,
        };
        this.cacheConfig = {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: true,
        };
        this.queryConfig = {
            parameters: {
                scopes: ["user.read"],
            },
            baseUrl: "https://graph.microsoft.com/v1.0",
        };
        this.accessToken = "";
        this.data = {
            isAuthenticated: false,
            query: {},
        };
        if (!config.auth.clientId) {
            throw new Error("auth.clientId option is required");
        }
        this.authConfig = Object.assign(this.authConfig, config.auth);
        this.cacheConfig = Object.assign(this.cacheConfig, config.cache);
        this.queryConfig = Object.assign(this.queryConfig, config.query);
        this.logger = config.logger || winston_1.default.createLogger();
        this.lib = new UserAgentApplicationExtended_1.UserAgentApplicationExtended({
            auth: {
                clientId: this.authConfig.clientId,
                authority: "https://" + this.authConfig.tenantName + "/" + this.authConfig.tenantId,
                validateAuthority: this.authConfig.validateAuthority,
                redirectUri: this.authConfig.redirectUri,
                postLogoutRedirectUri: this.authConfig.postLogoutRedirectUri,
                navigateToLoginRequestUrl: this.authConfig.navigateToLoginRequestUrl,
            },
            cache: this.cacheConfig,
            system: lodash_1.cloneDeep(config.system),
        });
        if (this.authConfig.requireAuthOnInitialize) {
            this.login();
        }
        this.data.isAuthenticated = this.isAuthenticated();
        if (this.data.isAuthenticated) {
            this.data.user = this.lib.getAccount();
        }
    }
    MSAL.prototype.login = function () {
        if (!this.isAuthenticated()) {
            this.lib.loginRedirect(this.queryConfig.parameters);
        }
    };
    MSAL.prototype.logout = function () {
        if (this.isAuthenticated()) {
            this.lib.logout();
        }
    };
    MSAL.prototype.isAuthenticated = function () {
        return (!this.lib.isCallback(window.location.hash) &&
            !lodash_1.isEmpty(this.lib.getAccount()));
    };
    MSAL.prototype.query = function (endpoint, options, parameters) {
        if (options === void 0) { options = {
            method: "GET",
            responseType: "json",
        }; }
        if (parameters === void 0) { parameters = this.queryConfig.parameters; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, this.acquireToken(parameters)];
                    case 1:
                        _a.accessToken = _b.sent();
                        return [4, this.executeQuery(endpoint, options)];
                    case 2:
                        response = _b.sent();
                        if (typeof endpoint === "object" && endpoint.id !== undefined) {
                            this.data.query[endpoint.id] = response.data;
                        }
                        return [2, response];
                }
            });
        });
    };
    MSAL.prototype.executeQuery = function (endpoint, options) {
        return __awaiter(this, void 0, void 0, function () {
            var query;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = this.createQuery(endpoint, options);
                        if (query.url.search("http") !== 0 &&
                            this.queryConfig.baseUrl !== undefined) {
                            query.url = "" + this.queryConfig.baseUrl + query.url;
                        }
                        query.headers = __assign(__assign({}, query.headers), { Authorization: "Bearer " + this.accessToken });
                        return [4, axios_1.default.request(query).catch(function (error) {
                                _this.logger.log({ level: "error", message: error.message, error: error });
                                throw error;
                            })];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    MSAL.prototype.createQuery = function (endpoint, options) {
        if (options === void 0) { options = {}; }
        if (typeof endpoint === "string") {
            endpoint = { url: endpoint };
        }
        if (endpoint.url === "") {
            throw new Error("URL endpoint must not be empty");
        }
        var query = __assign(__assign({}, options), { url: endpoint.url });
        return query;
    };
    MSAL.prototype.acquireToken = function (queryParameters) {
        if (queryParameters === void 0) { queryParameters = this.queryConfig.parameters; }
        return __awaiter(this, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.lib.acquireTokenSilent(queryParameters)];
                    case 1:
                        response = _a.sent();
                        this.setAccessToken(response.accessToken, response.expiresOn, response.scopes);
                        return [2, this.accessToken];
                    case 2:
                        error_1 = _a.sent();
                        this.logger.log({ level: "error", message: error_1.message, meta: error_1 });
                        if (this.requiresInteraction(error_1.errorCode)) {
                            this.lib.acquireTokenRedirect(queryParameters);
                        }
                        return [2, ""];
                    case 3: return [2];
                }
            });
        });
    };
    MSAL.prototype.requiresInteraction = function (errorCode) {
        if (!errorCode) {
            return false;
        }
        return (errorCode === types_1.ErrorCode.ConsentRequired ||
            errorCode === types_1.ErrorCode.InteractionRequired ||
            errorCode === types_1.ErrorCode.LoginRequired);
    };
    MSAL.prototype.setAccessToken = function (accessToken, expiresOn, scopes) {
        var _this = this;
        var _a;
        this.accessToken = accessToken;
        var tokenRenewalOffset = (_a = this.lib.configuration.system) === null || _a === void 0 ? void 0 : _a.tokenRenewalOffsetSeconds;
        var expirationOffset = tokenRenewalOffset || 0;
        var expiration = expiresOn.getTime() - new Date().getTime() - expirationOffset;
        if (this.tokenExpirationTimer) {
            clearTimeout(this.tokenExpirationTimer);
        }
        this.tokenExpirationTimer = window.setTimeout(function () {
            if (_this.authConfig.autoRefreshToken) {
                _this.acquireToken({ scopes: scopes });
            }
            else {
                _this.accessToken = "";
            }
        }, expiration);
    };
    return MSAL;
}());
exports.MSAL = MSAL;
